var map = {
	"./covvi_go.png": 4010,
	"./covvi_hand.png": 3743,
	"./electrode.png": 6488,
	"./other_product.png": 7608,
	"./power_supply.png": 3637,
	"./web_portal.png": 7197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6333;